import React from 'react';
import styled from 'styled-components';
import { MediaQuery } from '../Common';

import colors from '../../libs/colors';

const cover = {
  position: 'fixed',
  top: '0px',
  right: '0px',
  bottom: '0px',
  left: '0px',
  zIndex: 9,
};

export const SearchMenu = ({ children, onClose }) => {
  return (
    <>
      <div style={cover} onClick={onClose} />
      <MediaQuery min={1424}>
        <div
          style={{
            position: 'absolute',
            left: 0,
            top: 100,
            width: '100%',
            display: 'flex',
            zIndex: 10,
            height: 300,
            justifyContent: 'center',
            backgroundColor: 'white',
          }}
        >
          <div style={{ width: '1000px', paddingTop: 20 }}>{children}</div>
        </div>
      </MediaQuery>
      <MediaQuery max={1423}>
        <div
          style={{
            position: 'absolute',
            left: 0,
            top: 60,
            width: '100%',
            display: 'flex',
            zIndex: 10,
            justifyContent: 'center',
            backgroundColor: 'white',
          }}
        >
          <div style={{ width: '1000px', paddingTop: 10 }}>{children}</div>
        </div>
      </MediaQuery>
    </>
  );
};

export const SearchMenuV2 = ({ children, onClose }) => {
  return (
    <>
      <MediaQuery min={1424}>
        <div
          style={{
            width: '40%',
            display: 'flex',
            zIndex: 10,
            height: 100,
            justifyContent: 'center',
            backgroundColor: 'white',
            marginTop: 40,
          }}
        >
          <div style={{ width: '1000px', paddingTop: 20 }}>{children}</div>
        </div>
      </MediaQuery>
      <MediaQuery max={1423}>
        <div
          style={{
            width: '100%',
            display: 'flex',
            zIndex: 10,
            justifyContent: 'center',
            backgroundColor: 'white',
            marginTop: 10,
          }}
        >
          <div style={{ width: '1000px', paddingTop: 10 }}>{children}</div>
        </div>
      </MediaQuery>
    </>
  );
};

export const SearchMenuV3 = ({ children, onClose }) => {
  return (
    <>
      <MediaQuery min={1424}>
        <div
          style={{
            // position: 'relative',
            right: 0,
            top: 0,
            width: '100%',
            display: 'flex',
            zIndex: 10,
            height: 100,
            justifyContent: 'center',
            backgroundColor: 'white',
            
          }}
        >
          <div style={{ width: '1000px', paddingTop: 20 }}>{children}</div>
        </div>
      </MediaQuery>
      <MediaQuery max={1423}>
        <div
          style={{
            position: 'relative',
            right: 0,
            top: 0,
            width: '100%',
            display: 'flex',
            zIndex: 10,
            justifyContent: 'center',
            backgroundColor: 'white',
          }}
        >
          <div style={{ width: '1000px', paddingTop: 10 }}>{children}</div>
        </div>
      </MediaQuery>
    </>
  );
};

export const SearchBase = ({ children }) => {
  return (
    <>
      <MediaQuery min={1424}>
        <div
          style={{
            display: 'flex',
            borderBottomColor: colors.color6,
            borderBottomStyle: 'solid',
            // borderBlockWidth: 1,
            borderWidth:'thin',
            paddingLeft: 15,
            paddingTop: 15,
            paddingBottom: 5,
          }}
        >
          {children}
        </div>
      </MediaQuery>
      <MediaQuery max={1423}>
        <div
          style={{
            display: 'flex',
            borderBottomColor: colors.color6,
            borderBottomStyle: 'solid',
            // borderBlockWidth: 1,
            borderWidth:'thin',
            paddingLeft: 10,
            paddingTop: 5,
            paddingBottom: 5,
          }}
        >
          {children}
        </div>
      </MediaQuery>
    </>
  );
};
export const SearchBaseV2 = ({ children }) => {
  return (
    <>
      <MediaQuery min={1424}>
        <div
          style={{
            display: 'flex',
            borderColor: colors.color6,
            borderStyle: 'solid',
            borderRadius:30,
            // borderBlockWidth: 1,
            borderWidth:'thin',
            paddingLeft: 15,
            paddingTop: 8,
            paddingBottom: 8,
            marginRight:10
          }}
        >
          {children}
        </div>
      </MediaQuery>
      <MediaQuery max={1423}>
        <div
          style={{
            display: 'flex',
            borderBottomColor: colors.color6,
            borderBottomStyle: 'solid',
            // borderBlockWidth: 1,
            borderWidth:'thin',
            paddingLeft: 10,
            paddingTop: 5,
            paddingBottom: 5,
          }}
        >
          {children}
        </div>
      </MediaQuery>
    </>
  );
};


export const SearchResults = ({ children }) => {
  return (
    <>
      <MediaQuery min={1424}>
        <div style={{ paddingTop: 20, paddingBottom: 20 }}>{children}</div>
      </MediaQuery>
      <MediaQuery max={1423}>
        <div style={{ paddingTop: 5, paddingBottom: 5 }}>{children}</div>
      </MediaQuery>
    </>
  );
};

export const ResultsItem = ({ children }) => {
  return (
    <>
      <MediaQuery min={1424}>
        <div style={resultsItem}>{children}</div>
      </MediaQuery>
      <MediaQuery max={1423}>
        <div style={{ ...resultsItem, fontSize: 16, lineHeight: '20px' }}>{children}</div>
      </MediaQuery>
    </>
  );
};

export const Hightlight = styled.span`
  font-family: 'NSCJKrB';
`;

const resultsItem = {
  fontFamily: 'NSCJKrR',
  fontSize: 18,
  colors: 'black',
  paddingLeft: 15,
  paddingRight: 15,
  lineHeight: '40px',
  cursor: 'pointer',
};
